import React from 'react';
import { useDropzone } from 'react-dropzone';
import '../styles/MediaUpload.css';
import { baseUrl } from '../config';



function MediaUpload({ onMediaUpload }) {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => onMediaUpload(acceptedFiles[0]),
    accept: 'video/*,audio/*',
  });

  return (
    <div className="media-upload-container" {...getRootProps()}>
      <input {...getInputProps()} />
      <div className="upload-icon">📂</div>
      <p>Drag & drop media or click to upload</p>
    </div>
  );
}

export default MediaUpload;

